"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const vue_1 = require("vue");
const icon_png_1 = __importDefault(require("./assets/icon.png"));
const h1_png_1 = __importDefault(require("./assets/h1.png"));
const a1_png_1 = __importDefault(require("./assets/a1.png"));
const a2_png_1 = __importDefault(require("./assets/a2.png"));
const a3_png_1 = __importDefault(require("./assets/a3.png"));
const a4_png_1 = __importDefault(require("./assets/a4.png"));
const i1_png_1 = __importDefault(require("./assets/i1.png"));
const i2_png_1 = __importDefault(require("./assets/i2.png"));
const i3_png_1 = __importDefault(require("./assets/i3.png"));
exports.default = (0, vue_1.defineComponent)({
    props: {
        androidChannel: {
            type: String,
            default: '30024',
        },
    },
    setup(props) {
        const isIOS = !!navigator.userAgent.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
        const androidMeta = [
            {
                title: '海量动态壁纸随心换',
                src: [a1_png_1.default],
            },
            {
                title: '百变主题风格多样',
                src: [a2_png_1.default],
            },
            {
                title: '爆火充电铃声 个性十足',
                src: [a3_png_1.default],
            },
            {
                src: [a4_png_1.default],
            },
        ];
        const iosMeta = [
            {
                title: 'iOS16 锁屏小组件',
                src: [i1_png_1.default],
            },
            {
                title: '百变桌面主题任意换',
                src: [i2_png_1.default],
            },
            {
                title: '精美壁纸应有尽有',
                src: [i3_png_1.default],
            },
        ];
        const data = (0, vue_1.computed)(() => isIOS ? iosMeta : androidMeta);
        return {
            h1: h1_png_1.default,
            isIOS,
            data,
            icon: icon_png_1.default,
            download() {
                if (isIOS) {
                    location.href = 'https://apps.apple.com/cn/app/id1541785644';
                }
                else {
                    location.href = `https://mobile-wallpaper-cdn.zhhainiao.com/mobile/package/cfwallpaper_cn${props.androidChannel}.apk`;
                }
            },
        };
    },
    mounted() {
        function calcRootFontSize() {
            const _remRate = 750 / 100;
            const _initFontSize = window.innerWidth / _remRate;
            document.documentElement.style.fontSize = `${_initFontSize}px`;
        }
        calcRootFontSize();
        window.addEventListener('resize', calcRootFontSize);
    },
});
